import { Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Input, Switch, Tooltip, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import instance from "../../redux/api";
import { numberFormatter } from "../../utils/generalFunctions";
import { CustomLoader } from "../CustomLoader";
import { commonToast } from "../common";
import { CommonButton } from "../common/commonButton";
import DialogBox from "../common/dialog";
import AddNewAllocation from "./AddNewAllocation";
import AllocationsTable from "./AllocationsTable";
import AllocationDetails from "./AllocationDetails";
import CashAllocationEdit from "./CashAllocationEdit";
import CorrectionTypes from "./CorrectionTypes";
import CorrectiveTransfer from "./CorrectiveTransfer";
import FileUpload from "./FileUpload";
import "./cash-allocation.scss";
import "../common/commonPageStyles.css";
import { format } from "date-fns";
import {
  useAllocationList,
  useBankDetails,
  useCreateContraWorkflow,
  useSearchParams,
} from "./hooks";
import { parseDate } from "./utils";
import { ROEFILTERAPI } from "../../Services/api";
import { 
  PolicySharp,
  Visibility,
  VisibilityOff,
  AccountBalance,
  AccountBalanceWallet,
  Business,
  CalendarToday,
  Receipt,
  LocationOn,
  Payment,
  CurrencyExchange,
  AttachMoney,
  AccountBalanceOutlined
} from "@mui/icons-material";

export default function DataTable() {
  const cashAllocationDetailsClose = "action-button filled pill danger";

  const { userData } = useSelector((state) => state?.user);

  const transactionId = useSearchParams("txn_id");
  const policyRef = useSearchParams("policy_ref");
  const [policyRefNo, setPolicyRefNo] = useState(policyRef);
  const [selectedRows, setSelectedRows] = useState([]);
  const [addingRecord, setAddingRecord] = useState(false);
  const [validationStatus, setValidationStatus] = useState([]);
  const [isEditingRecord, setIsEditingRecord] = useState(null);
  const { bankDetails, transactionDetails, isBankDetailsApiInProgress } =
    useBankDetails(transactionId);
  // const [selectedRowIndex, setSelectedRowIndex] = useState(-1);
  const [isAPIInProgress, setIsAPIInProgress] = useState(false);
  const [showTransactionDetails, setShowTransactionDetails] = useState(true);
  const [openDeleteConfirmDialog, setOpenDeleteConfirmDialog] = useState(false);
  const [isDeleteInProgress, setIsDeleteInProgress] = useState(false);

  const [triggerCTWorkflow, setTriggerCTWorkflow] = useState(false);
  const [triggerCorrectionTypesWorkflow, setTriggerCorrectionTypesWorkflow] =
    useState(false);
  const [currentAllocation, setCurrentAllocation] = useState(null);
  const [cashAllocationDetailsEditOpen, setCashAllocationDetailsEditOpen] =
    useState(false);
  const [updatedFields, setUpdatedFields] = useState({});

  // Contra Allocation States
  const [associatedAllocationActivities, setAssociatedAllocationActivities] =
    useState({});
  const [
    openContraAllocationConfirmDialog,
    setOpenContraAllocationConfirmDialog,
  ] = useState(false);
  const [contraAllocationDialogBody, setContraAllocationDialogBody] =
    useState("");
  const [contraComment, setContraComment] = useState("");
  const [contraReferencePolicies, setContraReferencePolicies] = useState([]);
  const [
    contraReferencePoliciesInputsValues,
    setContraReferencePoliciesInputsValues,
  ] = useState({});

  const [showContraAddNewAllocation, setShowContraAddNewAllocation] =
    useState(false);
  // Global Loader
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    console.log("contraReferencePolicies", contraReferencePolicies)
    console.log("contraReferencePoliciesInputsValues", contraReferencePoliciesInputsValues)
  }, [contraReferencePoliciesInputsValues, contraReferencePolicies])
  const [isAuthorizedUser, setIsAuthorizedUser] = useState(false);

  const [openDialogueId, setOpenDialogueId] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuId, setMenuId] = useState(null);
  const [dialogueAllocation, setDialogueAllocation] = useState(null);
  
  // State for AllocationDetails component
  const [selectedAllocationDetails, setSelectedAllocationDetails] = useState(null);
  const [selectedAssociatedActivities, setSelectedAssociatedActivities] = useState([]);
  const [selectedRowMode, setSelectedRowMode] = useState("EDIT");

  // hooks
  const {
    allocationList,
    setAllocationList,
    allocationsWithInitialStatus,
    saveAllocationData,
    deleteAllocationData,
    totalAllocatedAmount,
    totalReceivableAmount,
    loadData,
    apiProgressBar,
    setApiProgressBar,
    selectedRowIndex,
    setSelectedRowIndex,
    isEditPolicy,
    setIsEditPolicy,
  } = useAllocationList(transactionId);

  useEffect(() => {
    // const allocationUserList = allocationList
    //   .map((item) => item?.policy_handler?.id)
    //   .filter((id) => id !== null && id !== undefined)
    if ((userData?.id && transactionDetails?.Assigned_User?.id && userData?.id === transactionDetails?.Assigned_User?.id)
      || !transactionDetails?.Assigned_User
      || userData?.role?.toLowerCase() === "manager"
      // || (userData?.id && allocationUserList.includes(userData?.id))
    ) {
      setIsAuthorizedUser(true);
    } else {
      setIsAuthorizedUser(false);
    }
  }, [userData, transactionDetails, allocationList]);

  const handleDeleteClick = async (id) => {
    try {
      setIsDeleteInProgress(true);
      const response = await deleteAllocationData(id);

      // close delete confirm dialog
      setOpenDeleteConfirmDialog(false);

      // Check if the deletion was successful
      if (response.status === 204 || response.status === 200) {
        // If successful, show a success toast
        commonToast("success", "Item deleted successfully");
        // If needed, update the state to reflect the deletion
        const updatedAllocations = allocationList.filter(
          (row) => row.id !== id
        );
        setAllocationList([...updatedAllocations]);
        setSelectedRows([]);
        setSelectedRowIndex(-1);
        setIsDeleteInProgress(false);
        if (allocationList.length > 0) {
          setPolicyRefNo(allocationList[0].id);
        }
      } else {
        // If deletion was not successful, show an error toast
        commonToast("error", `Error deleting item: ${response.statusText}`);
        setIsDeleteInProgress(false);
      }
    } catch (error) {
      // If an error occurs during deletion, show an error toast
      commonToast("error", `Error deleting item: ${error.message}`);
      setIsDeleteInProgress(false);
    }
  };

  const displayToastMessage = (message, type = "error") => {
    toast.error(message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 5000,
    });
  };

  // Trigger Auto Initiation of Corrective Transfer
  async function isAutoCorrectiveTransferTriggerd(allocationDetails) {
    try {
      let correctiveTransfers = null;
      try {
        // API Call to get corrective transfer details for allocation
        correctiveTransfers = await instance.get(
          `bankmanagement/get_corrective_by_allocation_id?cashallocation_id=${allocationDetails?.id}`
        );
      } catch (error) {
        if (error.status != 404) {
          commonToast("error", "Auto Intiation of corrective transfer failed.");

          return false;
        }
      }

      // Check if corrective Transfer already not exists for this allocation
      // Check if Producing Entity exists and not equal to receiving entity
      // Check if receivable amount is greater than 0
      if (
        allocationDetails?.allocation_status === "Allocated" &&
        (!correctiveTransfers ||
          !correctiveTransfers?.data ||
          correctiveTransfers?.data.length === 0) &&
        allocationDetails?.policy_fk?.Producing_Entity &&
        allocationDetails.policy_fk.Producing_Entity !==
        allocationDetails?.bank_txn?.bank_details?.entity_number &&
        allocationDetails?.receivable_amt != 0
      ) {
        setTriggerCTWorkflow(true);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      commonToast("error", "Auto Intiation of corrective transfer failed.");

      return false;
    }
  }

  function isAutoCorrectionTypesTriggered(allocationDetails) {
    try {
      const old_allocation_status =
        allocationDetails?.audit_fields?.fields?.filter(
          (field) => field.field_name === "allocation_status"
        )[0].old_value ?? "";
      if (
        allocationDetails?.allocation_status.startsWith("Query") &&
        allocationDetails?.allocation_status !== old_allocation_status
      ) {
        setTriggerCorrectionTypesWorkflow(true);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      commonToast("error", "Auto Intiation of correction reason failed.");
      return false;
    }
  }

  const handleSubmit = async ({ policy, ...item }) => {
    try {
      // Bank roe should be 1 when Bank_Currency_Code and original_ccy is same
      if (item?.bank_txn?.Bank_Currency_Code === item?.original_ccy) {
        item.bank_roe = 1.0;
      }
      if (Number(item?.bank_roe) <= 0) {
        displayToastMessage("Bank ROE cannot be Zero");
        return;
      }

      // Add validation for SCM and Non-SCM binding agreement
      if (["SCM", "Non-SCM"].includes(item?.binding_agreement)) {
        const missingFields = [];
        if (!item?.XFIbatchno || item?.XFIbatchno === "0")
          missingFields.push("Batch");
        if (!item?.cash_reference) missingFields.push("Cash Reference");

        if (missingFields.length > 0) {
          displayToastMessage(
            `${missingFields.join(", ")} ${missingFields.length === 1 ? "is" : "are"
            } mandatory for ${item.binding_agreement} binding agreement`
          );
          return;
        }
      }

      // Trigger UI Notification when allocation_status is Allocated and Receivable, Allocated amounts are Zero
      if (item?.allocation_status === "Allocated") {
        if (Number(item?.receivable_amt) === 0) {
          displayToastMessage("Receivable amount cannot be Zero");
          return;
        }
        if (Number(item?.allocated_amt) === 0) {
          displayToastMessage("Allocated amount cannot be Zero");
          return;
        }
        if (
          parseFloat(item?.receivable_amt) != parseFloat(item?.allocated_amt)
        ) {
          displayToastMessage("Remaining Balance should be Zero");
          return;
        }
        // Added by Gaurav on 28-11-2024
        item.allocatedby = userData.user_name;
        item.allocation_date = parseDate(new Date());
      }

      setCurrentAllocation(item);

      // Update audit fields
      const { audit_fields: auditFields } = item;
      auditFields.fields[0].value = item?.policy_id;
      auditFields.fields[1].value = item?.allocation_status;
      auditFields.fields[2].value = item?.receivable_amt;
      auditFields.fields[3].value = item?.allocated_amt;
      auditFields.user_id = userData?.id;

      const payload = {
        ...item,
        bank_txn: item?.bank_txn?.id ?? 0,
        policy_fk: item?.policy_fk?.id ?? null,
        policy_pk: item?.policy_pk ?? item?.policy_fk?.id,
        policy_mf: item?.policy_mf ?? [],
        audit_fields: auditFields,
        updatedFields: updatedFields[selectedRowIndex] || {},
      };
      setIsAPIInProgress(true);
      const response = await saveAllocationData(payload);
      setIsAPIInProgress(false);

      if (response.status === 200 || response.status === 201) {
        let shouldReload = true;

        // Auto Initiation of Corrective transfer check
        const isAutoInitiationTriggered =
          await isAutoCorrectiveTransferTriggerd(item);
        if (isAutoInitiationTriggered) {
          shouldReload = false;
        }

        // Auto Initiation of Correction Type check
        const isCorrectionTypesAutoInitiationTriggered =
          isAutoCorrectionTypesTriggered(item);

        if (isCorrectionTypesAutoInitiationTriggered) {
          shouldReload = false;
        }

        commonToast("success", "Item Updated successfully!");

        if (shouldReload) {
          await loadData();
          // Clear the updated fields for this row after save
          setUpdatedFields((prev) => {
            const newState = { ...prev };
            delete newState[selectedRowIndex];
            return newState;
          });
        }
      }
    } catch (err) {
      console.error("Error:", err);
      setIsAPIInProgress(false);
      commonToast(
        "error",
        err?.data?.msg || "Unable to save cash allocation data"
      );
    }
  };

  const startAddingNewRow = () => {
    if (isAuthorizedUser) {
      setAddingRecord(true);
    } else {
      toast.error(
        "You are not assigned user!! Please re-assign and then try.",
        {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        }
      );
    }
  };

  const [isAddRow, setIsAddRow] = useState(false)

  const handleAddRow = (data, show_toast = true) => {
    if (show_toast) {
      commonToast("success", "Successfully Added new allocation!");
    }
    setPolicyRefNo(data?.id);
    setIsAddRow(true);

    if (data?.bank_txn) {
      loadData(data?.policy_id);
    } else {
      try {
        instance
          .get(
            `bankmanagement/get_transactions_by_txn_id/?txn_id=${encodeURIComponent(
              data?.bank_txn
            )}`
          )
          .then((response) => {
            let data = response.data;
            // disable the row then when the allocation status is "Allocated"
            data = data?.map((item) => {
              return {
                ...item,
                disabled: item?.allocation_status === "Allocated",
                audit_fields: {
                  user_id: userData?.id,
                  fields: [
                    {
                      field_name: "policy_id",
                      old_value: item?.policy_id,
                      value: item?.policy_id,
                    },
                    {
                      field_name: "allocation_status",
                      old_value: item?.allocation_status,
                      value: item?.allocation_status,
                    },
                    {
                      field_name: "receivable_amt",
                      old_value: item?.receivable_amt,
                      value: item?.receivable_amt,
                    },
                    {
                      field_name: "allocated_amt",
                      old_value: item?.allocated_amt,
                      value: item?.allocated_amt,
                    },
                  ],
                  txn_id: item?.audit_txn?.id,
                  audit_txn_name: "CASH_ALLOCATION",
                },
              };
            });
            setAllocationList([...data]);
          })
          .catch((error) => {
            console.error("Error fetching allocations:", error);
            commonToast("error", "Unable fetch the added new allocation!");
          });
      } catch (err) {
        console.error("err", err);
      }
    }

    cancelAddRow();
  };

  const cancelAddRow = () => {
    setAddingRecord(false);
    setIsEditingRecord(null);
  };

  // Add state for modal visibility
  const [isPolicyErrorModalOpen, setIsPolicyErrorModalOpen] = useState(false);

  // Function to handle modal close
  const handleClosePolicyErrorModal = () => {
    setIsPolicyErrorModalOpen(false);
  };

  const handleDeleteRow = async () => {
    if (selectedRowIndex === -1) {
      commonToast("error", `Please select one row to delete`);
      return;
    }

    if (allocationList[selectedRowIndex]?.is_contra_allocation) {
      commonToast("error", "Contra allocation cannot be deleted.");

      return;
    }

    if (allocationList[selectedRowIndex]?.child_contra_id > 0) {
      commonToast(
        "error",
        "Can't delete allocation which has contra allocation"
      );

      return;
    }

    try {
      const response = await instance.get(
        `bankmanagement/cash_allocation_activities/${allocationList[selectedRowIndex].id}/`
      );
      if (response.status === 200 && response.data.message === "Success") {
        setOpenDeleteConfirmDialog(true);
      } else {
        //setErrorText(response.data.data)
        setOpenDeleteConfirmDialog(true);
        // setIsPolicyErrorModalOpen(true);
      }
    } catch (error) {
      commonToast("error", "Error while getting details of the policy");
    }
  };

  const handleEditRow = () => {
    if (selectedRowIndex === -1) {
      commonToast("error", "Error while getting details of the policy");
      return;
    }

    if (allocationList[selectedRowIndex]?.is_contra_allocation) {
      commonToast("error", "Contra allocation cannot be edited.");
      return;
    }

    if (allocationList[selectedRowIndex]?.child_contra_id > 0) {
      commonToast("error", "Can't edit allocation which has contra allocation");
      return;
    }

    setCashAllocationDetailsEditOpen(true);
  };

  const toggleTransactionDetails = useCallback(() => {
    setShowTransactionDetails((t) => !t);
  }, [setShowTransactionDetails]);

  const handleDeleteCancelled = () => {
    setOpenDeleteConfirmDialog(false);
  };

  const handleDeleteConfirmed = () => {
    const row = allocationList[selectedRowIndex];
    handleDeleteClick(row.id);
  };

  async function handleContraAllocationClick() {
    try {
      setIsLoading(true);
      let contraRow = allocationList[selectedRowIndex];
      const allocationId = contraRow.id;

      if (contraRow?.is_contra_allocation) {
        toast.error(
          "Contra allocation cannot be added to an existing contra allocation entry.",
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          }
        );

        setIsLoading(false);
        return;
      }

      if (contraRow?.child_contra_id > 0) {
        toast.error(
          "Multiple contra allocations cannot be added to the same entry.",
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          }
        );

        setIsLoading(false);
        return;
      }

      // Handle Workflows on Contra Allocation
      let associatedActivities = await getAssociatedAllocationActivities(
        allocationId
      );
      setAssociatedAllocationActivities((prevState) => ({
        ...prevState,
        [allocationId]: associatedActivities,
      }));

      setIsLoading(false);
      setOpenContraAllocationConfirmDialog(true);
    } catch (error) {
      setIsLoading(false);

      // If an error occurs during contra creation, show an error toast
      toast.error(`Error creating Contra Allocation`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
    }
  }

  async function getAssociatedAllocationActivities(allocationId) {
    try {
      // retrieve workflows list for the allocation
      const response = await instance.get(
        `bankmanagement/cash_allocation_activities/${allocationId}/`
      );
      if (response.status === 200) {
        let dialogueBody = (
          <>
            <b>Are you sure you want to create a Contra Allocation ?</b>
          </>
        );
        let associatedActivities = null;

        // success here defines no activities associated
        if (response.data.message != "Success") {
          associatedActivities = response.data.data;

          dialogueBody = (
            <>
              The following activities are associated with the selected
              allocation : <br />
              <ul style={{ margin: "10px 0", paddingLeft: "20px" }}>
                {Object.keys(associatedActivities).map((key, index) => (
                  <li key={index} style={{ marginBottom: "2px" }}>
                    {key}
                  </li>
                ))}
              </ul>
              <b>Are you sure you want to create a Contra Allocation?</b>
            </>
          );
        }

        setContraAllocationDialogBody(dialogueBody);
        return associatedActivities;
      } else {
        const errorMessage =
          "Error While Retrieving Associated Allocation Activities";
        console.error(errorMessage);
        throw new Error(errorMessage);
      }
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }

  const CustomContraBody = () => {
    return (
      <div
        style={{
          width: "100%",
          minWidth: "600px",
          padding: "15px",
          fontSize: "14px",
          textAlign: "left",
        }}
      >
        {contraAllocationDialogBody && (
          <div style={{ marginBottom: "20px", fontSize: "14px", lineHeight: "1.5" }}>
            {contraAllocationDialogBody}
          </div>
        )}

        <div style={{ marginBottom: "20px" }}>
          <CommonButton
            text="Add Policy"
            handleClick={() => setShowContraAddNewAllocation(true)}
            sx={{ 
              borderRadius: "6px",
              backgroundColor: "#1672DE !important",
              color: "white !important",
              padding: "10px 20px",
              fontWeight: "500",
              fontSize: "14px",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#1565c0 !important",
              }
            }}
            hoverColor="#1565c0"
          />
        </div>

        {/* Show the table of added reference policies directly */}
        <div style={{ marginBottom: "20px" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "14px",
              backgroundColor: "#fff",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#f8f9fa" }}>
                <th
                  style={{
                    border: "1px solid #e0e0e0",
                    padding: "16px",
                    fontWeight: "600",
                    textAlign: "left",
                    fontSize: "14px",
                    width: "35%",
                  }}
                >
                  Policy
                </th>
                <th
                  style={{
                    border: "1px solid #e0e0e0",
                    padding: "16px",
                    fontWeight: "600",
                    textAlign: "center",
                    fontSize: "14px",
                    width: "45%",
                  }}
                >
                  Receivable Amount
                  <div style={{ 
                    fontWeight: "normal", 
                    fontSize: "12px", 
                    color: "#666",
                    marginTop: "4px"
                  }}>
                    [Total Amount To Allocate:{" "}
                    {allocationList &&
                      allocationList[selectedRowIndex] &&
                      allocationList[selectedRowIndex].receivable_amt
                      ? allocationList[selectedRowIndex].receivable_amt
                      : 0}
                    ]
                  </div>
                </th>
                <th
                  style={{
                    border: "1px solid #e0e0e0",
                    padding: "16px",
                    fontWeight: "600",
                    textAlign: "center",
                    fontSize: "14px",
                    width: "20%",
                  }}
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {contraReferencePolicies.length > 0 ? (
                contraReferencePolicies.map((policyData, index) => {
                  const policyIdentifier =
                    policyData.policyIdentifier || policyData.Policy_Line_Ref;
                  return (
                    <tr key={policyIdentifier} style={{ backgroundColor: index % 2 === 0 ? "#fff" : "#fafafa" }}>
                      <td style={{ 
                        border: "1px solid #e0e0e0", 
                        padding: "16px",
                        fontSize: "14px",
                        fontWeight: "500"
                      }}>
                        {policyIdentifier}
                      </td>
                      <td style={{ 
                        border: "1px solid #e0e0e0", 
                        padding: "16px",
                        textAlign: "center"
                      }}>
                        <div
                          style={{
                            position: "relative",
                            width: "200px",
                            margin: "0 auto",
                            padding: "8px 12px",
                          }}
                        >
                          <Input
                            type="number"
                            value={
                              contraReferencePoliciesInputsValues[
                              policyIdentifier
                              ] || ""
                            }
                            onChange={(e) =>
                              setContraReferencePoliciesInputsValues(
                                (prev) => ({
                                  ...prev,
                                  [policyIdentifier]: e.target.value,
                                })
                              )
                            }
                            disableUnderline
                            style={{
                              textAlign: "center",
                              width: "100%",
                              background: "transparent",
                              zIndex: 1,
                              position: "relative",
                              fontSize: "14px",
                              padding: "4px 8px",
                            }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              left: "12px",
                              right: "12px",
                              top: "65%",
                              borderBottom: "2px solid #888",
                              zIndex: 0,
                            }}
                          />
                        </div>
                      </td>
                      <td style={{ 
                        border: "1px solid #e0e0e0", 
                        padding: "16px",
                        textAlign: "center"
                      }}>
                        <CommonButton
                          text="Remove"
                          handleClick={() =>
                            removeContraPolicy(policyIdentifier)
                          }
                          sx={{ 
                            borderRadius: "6px", 
                            fontSize: "12px",
                            backgroundColor: "#dc3545 !important",
                            color: "white !important",
                            padding: "6px 16px",
                            fontWeight: "500",
                            textTransform: "none",
                            "&:hover": {
                              backgroundColor: "#c82333 !important",
                            }
                          }}
                          hoverColor="#c82333"
                        />
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan="3"
                    style={{
                      textAlign: "center",
                      padding: "40px 20px",
                      color: "#666",
                      fontSize: "14px",
                      fontStyle: "italic",
                      backgroundColor: "#fafafa",
                    }}
                  >
                    No policies added yet. Click "Add Policy" to add reference policies.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div>
          <label style={{ 
            display: "block", 
            marginBottom: "8px", 
            fontSize: "14px", 
            fontWeight: "500" 
          }}>
            Comments *
          </label>
          <textarea
            style={{
              width: "100%",
              maxWidth: "500px",
              height: "80px",
              padding: "12px",
              border: "1px solid #e0e0e0",
              borderRadius: "6px",
              fontSize: "14px",
              fontFamily: "inherit",
              resize: "vertical",
              outline: "none",
              "&:focus": {
                borderColor: "#1672DE",
                boxShadow: "0 0 0 2px rgba(22, 114, 222, 0.2)",
              }
            }}
            placeholder="Enter your comments..."
            value={contraComment}
            onChange={(e) => setContraComment(e.target.value)}
          />
        </div>
      </div>
    );
  };

  async function createContraManualPolicies(policyData) {
    /**
     * Create a manual contra policy by sending payload to the API.
     */
    try {
      const payload = {
        Binding_Agreement: policyData.Binding_Agreement,
        Installment_Agency_Amount_in_Orig: policyData.Installment_Agency_Amount_in_Orig || null,
        Installment_Due_date: policyData.Installment_Due_date || null,
        Instalment_Nbr: policyData.Instalment_Nbr || null,
        Policy_Line_Ref: policyData.Policy_Line_Ref,
        Producing_Entity: policyData.Producing_Entity,
        SCM_Insurer_partner_name: policyData.SCM_Insurer_partner_name?.trim() || null,
        SCM_Partner: policyData.SCM_Partner?.trim() || null,
        Syndicate_Binder: policyData.Syndicate_Binder,
        Third_Party_Capacity: policyData.Third_Party_Capacity,
        Three_Party_Capacity_Deployed: policyData.Binding_Agreement === "SCM" ? "Yes" : "No",
        UMR_Number: policyData.UMR_Number,
        allocation_invoice_verification: policyData.allocation_invoice_verification,
        installment_amount_org: policyData.installment_amount_org,
        original_ccy: policyData.original_ccy,
        settlement_currency: policyData.settlement_currency
      };

      debugger
      const res = await instance.post("documents/policy_create/", payload);
      return res.status === 200 ? res.data.id : null;
    } catch (err) {
      console.error("Contra Manual Policy creation failed:", err);
      throw err;
    }
  }

  async function createContraReferencePoliciesDetails() {
    /**
     * Create allocation details for referenced contra policies.
     */
    try {
      const allocationDetails = [];

      for (const policyData of contraReferencePolicies) {
        const policyNumber = policyData.Policy_Line_Ref;
        const policy_receivable_amount = Number(contraReferencePoliciesInputsValues?.[policyNumber]) || 0;

        let policyId = policyData.id;
        if (policyData.isManual) {
          const manualPolicyId = await createContraManualPolicies(policyData);
          if (manualPolicyId) {
            policyId = manualPolicyId;
          }
        }

        allocationDetails.push({
          GXPbatchno: null,
          Third_Party_Capacity: policyData?.Three_Party_Capacity_Deployed ?? null,
          XFIbatchno: 0,
          accounting_monthyear: transactionDetails?.Accounting_Month
            ? format(new Date(transactionDetails.Accounting_Month), "yyyy-MM-dd")
            : null,
          allocated_amt: 0,
          allocatedby: null,
          allocation_binder: policyData.Syndicate_Binder || "-",
          allocation_date: null,
          allocation_eea: policyData.allocation_eea ?? null,
          allocation_entity: policyData.Producing_Entity || "-",
          allocation_invoice_verification: policyData.allocation_invoice_verification,
          allocation_scm: policyData.Binding_Agreement === "SCM" ? policyData.SCM_Partner ?? null : null,
          allocation_scmname: policyData.Binding_Agreement === "SCM" ? policyData.SCM_Insurer_partner_name || null : null,
          allocation_status: "In Progress - CC",
          allocation_systemid: "0",
          allocation_umr: policyData.UMR_Number || "-",
          audit_fields: {
            user_id: userData?.id,
            fields: [
              { field_name: "policy_id", old_value: null, value: policyNumber },
              { field_name: "allocation_status", old_value: null, value: "In Progress - CC" },
              { field_name: "receivable_amt", old_value: null, value: null },
              { field_name: "allocated_amt", old_value: null, value: null },
            ],
            txn_id: null,
            audit_txn_name: "CASH_ALLOCATION",
          },
          bank_curr: transactionDetails?.bank_details?.currency || "-",
          bank_roe: transactionDetails?.bank_roe || 0,
          bank_txn: transactionDetails.id,
          binding_agreement: policyData.Binding_Agreement === "SCM" ? "SCM" : "NON SCM",
          cash_reference: null,
          installment_number: policyData?.Instalment_Nbr ?? null,
          installment_duedate: policyData?.Installment_Due_date ?? null,
          installment_amount_org: policyData.isManual ? policyData.installment_amount_org ?? null : policyData.Installment_Agency_Amount_in_Orig ?? null,
          isActive: true,
          manual_entry: true,
          original_ccy: policyData.isManual ? policyData.original_ccy ?? null : policyData.Original_Ccy ?? null,
          payment_currency: policyData.isManual ? policyData.original_ccy || transactionDetails?.payment_currency : policyData.Original_Ccy || transactionDetails?.Payment_Currency_Code,
          policy_id: policyNumber,
          policy_pk: policyId,
          receivable_amt: policy_receivable_amount,
          settlement_currency: policyData.isManual ? policyData.settlement_currency ?? null : policyData.Settlement_Ccy ?? null,
          unallocated_amt: 0,
        });
      }

      return allocationDetails;
    } catch (err) {
      console.error("Contra Reference Policy Details creation failed:", err);
      throw err;
    }
  }

  function prepareContraReversalRow(contraRow) {
    /**
     * Prepares contra row data for reversal (negated values and cleanup).
     */
    contraRow.policy_pk = contraRow?.policy_fk?.id;
    contraRow.bank_txn = contraRow?.bank_txn?.id;
    contraRow.audit_txn = contraRow?.audit_txn?.id;
    contraRow.locked_by = contraRow?.locked_by?.id;
    contraRow.settlement_ccy = contraRow?.settlement_ccy?.id;
    contraRow.comment = contraComment;

    if (!contraRow.GXPbatchno) contraRow.GXPbatchno = null;

    // Negate all monetary amounts for reversal
    ["unallocated_amt", "allocated_amt", "receivable_amt", "installment_amount_org"].forEach(field => {
      contraRow[field] = -contraRow[field];
    });

    contraRow.referenced_contra_allocations = null;
    contraRow.is_contra_allocation = true;
    contraRow.parent_contra_id = contraRow.id;

    // Remove unnecessary fields
    delete contraRow.id;
    delete contraRow.policy_fk;
    delete contraRow.created_by;
    delete contraRow.updated_by;

    // Adjust audit fields
    contraRow.audit_fields.fields = contraRow.audit_fields.fields.map((field) => {
      if (["receivable_amt", "allocated_amt"].includes(field.field_name)) {
        return {
          ...field,
          old_value: -field.old_value,
          value: -field.value,
        };
      }
      return field;
    });

    return contraRow;
  }

  const { triggerContraWorkflow } = useCreateContraWorkflow();
  async function createContraAllocation() {
    /**
     * Function to create a contra allocation workflow or post it directly based on validation.
     */
    setIsLoading(true);

    if (!contraComment?.length) {
      toast.error("Comments are mandatory when creating a contra allocation.", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      setIsLoading(false);
      return;
    }

    try {
      const policyDetails = contraReferencePolicies.map((policy) => ({
        policy_id: policy.Policy_Line_Ref,
        receivable_amount: parseFloat(contraReferencePoliciesInputsValues[policy.Policy_Line_Ref] || 0),
      }));

      debugger
      const policy_cash_allocation_details = await createContraReferencePoliciesDetails();
      const contraRow = { ...allocationList[selectedRowIndex] };
      const contra_cash_allocation_details = prepareContraReversalRow(contraRow);

      const payload = {
        policy_cash_allocation_details,
        contra_cash_allocation_details,
        contraComment
      };

      const totalReferenceAmount = Object.values(contraReferencePoliciesInputsValues)
        .reduce((sum, val) => sum + parseFloat(val || 0), 0);

      // If mismatch, trigger approval workflow
      if (Math.abs(totalReferenceAmount) !== Math.abs(parseFloat(contraRow.receivable_amt))) {
        await triggerContraWorkflow({
          contra_allocation_payload: {
            bank_transaction_id: transactionId,
            policyDetails,
            ...payload
          },
          bank_txn_id: transactionDetails.id,
          comments: contraComment,
          initiated_user_id: userData?.id,
        });

        toast.success("Contra allocation sent for approval.", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });

      } else {
        const response = await instance.post("bankmanagement/create_contra_allocation/", payload);

        if (response?.data) {
          toast.success("Successfully Created Contra Policy", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          });
        }
      }

    } catch (error) {
      toast.error("Failed to Create Contra Policy", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
    } finally {
      setIsLoading(false);
      setOpenContraAllocationConfirmDialog(false);
      resetContraAllocationState();
      await loadData();
    }
  }

  // Not using this for now, We will use it in future if required
  // Hooks initialize for Contra Entries
  // const { createContraWriteOff } = useWriteOff(allocationList[selectedRowIndex]);
  // const { createContraCrossAllocation } = useCrossAllocation(allocationList[selectedRowIndex]);
  // const { createContraRefund } = useRefund(allocationList[selectedRowIndex]);
  // const { createContraTreasuryUpdate } = useTreasuryUpdate(allocationList[selectedRowIndex]);
  // const { createContraCfi } = useCfi(allocationList[selectedRowIndex]);
  // const { createContraMSD } = useMsd(allocationList[selectedRowIndex]);
  // const { createContraCorrectiveTransfer } = useCorrectiveTrf(allocationList[selectedRowIndex], transactionDetails);
  // const { createContraCorrectionType } = useAllocationIssues({allocation : allocationList[selectedRowIndex], transaction: transactionDetails});
  // async function handleAssociatedAllocationActivitiesOnContraAllocation(allocationId) {
  //   try {
  //     const associatedActivities = associatedAllocationActivities[allocationId];

  //     // Creating Contra Activities for the contra allocation
  //     for (let activity in associatedActivities) {
  //       for (let currentActivity of associatedActivities[activity]) {
  //         switch (activity.toLowerCase()) {
  //           case "write-off":
  //             await createContraWriteOff(currentActivity, allocationId);
  //           case "cross-allocation":
  //             await createContraCrossAllocation(currentActivity, allocationId);
  //           case "refund":
  //             await createContraRefund(currentActivity, allocationId);
  //           case "tresury-update":
  //             await createContraTreasuryUpdate(currentActivity, allocationId);
  //           case "cfi":
  //             await createContraCfi(currentActivity, allocationId);
  //           case "msd-update":
  //             await createContraMSD(currentActivity, allocationId);
  //           case "correction-types":
  //             await createContraCorrectionType(currentActivity, allocationId);
  //           case "corrective-transfer":
  //             await createContraCorrectiveTransfer(currentActivity, allocationId);
  //           default:
  //             throw new Error("Invalid Activity Type");
  //         }
  //       }
  //     }
  //   } catch (error) {
  //     toast.error("Failed to Create Contra Associated Policies", {
  //       position: toast.POSITION.TOP_RIGHT,
  //       autoClose: 1000,
  //     });
  //     console.error("Error Creating Contra Associated Policies: ", error);
  //   }
  // }

  const handleContraAddNewAllocationSuccess = (data) => {
    const policyKey = data.policyIdentifier || data.Policy_Line_Ref;

    const existingPolicy = contraReferencePolicies.find(
      (policy) =>
        (policy.policyIdentifier || policy.Policy_Line_Ref) === policyKey
    );

    if (existingPolicy) {
      toast.warning("This policy is already added to the contra allocation", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      setShowContraAddNewAllocation(false);
      return;
    }

    setContraReferencePolicies((prev) => [...prev, data]);
    // Use the policy identifier as the key for input values
    setContraReferencePoliciesInputsValues((prev) => ({
      ...prev,
      [policyKey]: "",
    }));
    setShowContraAddNewAllocation(false);
  };

  // Handle cancel from AddNewAllocation for contra allocation
  const handleContraAddNewAllocationCancel = () => {
    setShowContraAddNewAllocation(false);
    // Reset contra reference input values when closing modal
    setContraReferencePoliciesInputsValues({});
  };

  const removeContraPolicy = (policyIdentifier) => {
    setContraReferencePolicies((prev) =>
      prev.filter(
        (policy) =>
          (policy.policyIdentifier || policy.Policy_Line_Ref) !==
          policyIdentifier
      )
    );
    setContraReferencePoliciesInputsValues((prev) => {
      const newValues = { ...prev };
      delete newValues[policyIdentifier];
      return newValues;
    });
  };

  const resetContraAllocationState = () => {
    setContraReferencePolicies([]);
    setContraReferencePoliciesInputsValues({});
    setContraComment("");
  };

  const [ROEList, UpdateROEList] = useState([]);

  useEffect(() => {
    const fetchROEList = async () => {
      try {
        const response = await instance.get(ROEFILTERAPI);
        if (response.status === 200) {
          UpdateROEList(response?.data);
        } else {
          UpdateROEList([]);
        }
      } catch (error) {
        UpdateROEList([]);
        console.log("Failed to fetch ROE list", error);
      }
    };
    fetchROEList();
  }, []);

  return (
    <>
      {/* Page Loader */}
      {isLoading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.8)", // Semi-transparent background
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1400, // Ensure loader appears on top
          }}
        >
          <CircularProgress size={60} style={{ color: "#1672DE" }} />
        </Box>
      )}

      <div
        className={`cash-allocation-page ${showTransactionDetails ? "with-details" : "without-details"
          }`}
      >
        <div className="top-details-section">
          <Box className="page-header-container" sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "20px", flex: 1 }}>
              <Typography variant="h5" className="page-heading" sx={{ margin: 0, fontSize: "20px", fontWeight: "600", color: "#1672DE" }}>
                Cash Allocation Details
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <div className="cash-alloc-indicator historical" />
                  <span style={{ fontSize: "14px", color: "#666", fontWeight: "500" }}>Historical</span>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <div className="cash-alloc-indicator non-historical" />
                  <span style={{ fontSize: "14px", color: "#666", fontWeight: "500" }}>Non-Historical</span>
                </Box>
              </Box>
            </Box>
            <Box className="action-toolbar" sx={{ display: "flex", alignItems: "center", gap: "8px", flexShrink: 0 }}>
            {["manager", "cc processor"].includes(
              userData?.role?.toLowerCase()
            ) &&
              allocationList?.length > 0 &&
              allocationsWithInitialStatus[selectedRowIndex]
                ?.initialStatus === "Allocated" &&
              !allocationsWithInitialStatus[selectedRowIndex]
                ?.is_contra_allocation && (
                <CommonButton
                  text="Contra"
                  handleClick={() => handleContraAllocationClick()}
                  sx={{ 
                    borderRadius: "6px", 
                    backgroundColor: "#1672DE !important",
                    color: "white !important",
                    padding: "8px 18px",
                    fontWeight: "500",
                    fontSize: "14px",
                    textTransform: "none",
                    minHeight: "36px",
                    minWidth: "auto",
                    "&:hover": {
                      backgroundColor: "#1565c0 !important",
                    }
                  }}
                  hoverColor="#1565c0"
                />
              )}
            <CommonButton
              text="Add"
              handleClick={() => startAddingNewRow()}
              sx={{ 
                borderRadius: "6px",
                backgroundColor: "#1672DE !important",
                color: "white !important",
                padding: "8px 18px",
                fontWeight: "500",
                fontSize: "14px",
                textTransform: "none",
                minHeight: "36px",
                minWidth: "auto",
                "&:hover": {
                  backgroundColor: "#1565c0 !important",
                }
              }}
              hoverColor="#1565c0"
              disabled={apiProgressBar || isAPIInProgress || isBankDetailsApiInProgress || transactionDetails?.has_bank_txn_refund === true}
            />
            <CommonButton
              text="Edit"
              handleClick={() => handleEditRow()}
              sx={{ 
                borderRadius: "6px",
                backgroundColor: "#1672DE !important",
                color: "white !important",
                padding: "8px 18px",
                fontWeight: "500",
                fontSize: "14px",
                textTransform: "none",
                minHeight: "36px",
                minWidth: "auto",
                "&:hover": {
                  backgroundColor: "#1565c0 !important",
                }
              }}
              hoverColor="#1565c0"
              disabled={
                selectedRowIndex === -1 ||
                userData?.role?.toLowerCase() !== "manager" ||
                apiProgressBar ||
                isAPIInProgress ||
                isBankDetailsApiInProgress
              }
            />
            {allocationList?.length > 0 && (
              <CommonButton
                text="Delete"
                handleClick={() => handleDeleteRow()}
                sx={{ 
                  borderRadius: "6px",
                  backgroundColor: "#dc3545 !important",
                  color: "white !important",
                  padding: "8px 18px",
                  fontWeight: "500",
                  fontSize: "14px",
                  textTransform: "none",
                  minHeight: "36px",
                  minWidth: "auto",
                  "&:hover": {
                    backgroundColor: "#c82333 !important",
                  }
                }}
                hoverColor="#c82333"
                disabled={
                  userData?.role?.toLowerCase() !== "manager" ||
                  apiProgressBar ||
                  isAPIInProgress ||
                  isBankDetailsApiInProgress
                }
              />
            )}
            <CommonButton
              text="Close"
              handleClick={() => window.history.back()}
              sx={{
                borderRadius: "6px",
                backgroundColor: "#6c757d !important",
                color: "white !important",
                padding: "8px 18px",
                fontWeight: "500",
                fontSize: "14px",
                textTransform: "none",
                minHeight: "36px",
                minWidth: "auto",
                "&:hover": {
                  backgroundColor: "#5a6268 !important",
                },
              }}
              hoverColor="#5a6268"
            />
            </Box>
          </Box>

          <div className="transaction-details">
            <div className="transaction-details-header"> 
              <Box sx={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap", flex: 1 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <span className="page-title" style={{ color: "#1672DE", fontSize: "14px", fontWeight: "600" }}>View Bank Details</span>
                  <IconButton
                    onClick={toggleTransactionDetails}
                    size="small"
                    sx={{
                      color: "#1672DE",
                      padding: "4px",
                      "&:hover": {
                        backgroundColor: "rgba(22, 114, 222, 0.1)",
                      },
                    }}
                    aria-label="Toggle Bank Details Visibility"
                  >
                    {showTransactionDetails ? (
                      <Visibility sx={{ fontSize: 20 }} />
                    ) : (
                      <VisibilityOff sx={{ fontSize: 20 }} />
                    )}
                  </IconButton>
                </Box>
                <Box sx={{ 
                  display: "flex", 
                  alignItems: "center", 
                  gap: "20px", 
                  flexWrap: "wrap",
                  padding: "8px 16px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "6px",
                  border: "1px solid #e0e0e0",
                  minWidth: "fit-content"
                }}>
                  <span className="top-amount-details">
                    <strong>Bank Rcvd:</strong>
                    <span>
                      {transactionDetails?.Receivable_Amount !== undefined 
                        ? numberFormatter(transactionDetails.Receivable_Amount) 
                        : "0.00"}
                    </span>
                  </span>
                  <span className="top-amount-details">
                    <strong>Policy Prem:</strong>
                    <span>
                      {numberFormatter(totalReceivableAmount || 0)}
                    </span>
                  </span>
                  <span className="top-amount-details">
                    <strong>Alloc:</strong>
                    <span>{numberFormatter(totalAllocatedAmount || 0)}</span>
                  </span>
                  <span className="top-amount-details">
                    <strong>Unalloc:</strong>
                    <span>
                      {transactionDetails?.Receivable_Amount !== undefined
                        ? numberFormatter((transactionDetails.Receivable_Amount || 0) - (totalAllocatedAmount || 0))
                        : "0.00"}
                    </span>
                  </span>
                </Box>
              </Box>
              <Box sx={{ flexShrink: 0 }}>
                <FileUpload transaction={transactionDetails}/>
              </Box>
            </div>
            {showTransactionDetails && (
              <div className="transaction-details-card">
                {bankDetails.map(({ label, value }) => {
                  // Icon mapping for each field
                  const iconMap = {
                    "Bank Name": <AccountBalance sx={{ fontSize: 18, color: "#1672DE", mr: 1 }} />,
                    "Bank Account Number": <AccountBalanceWallet sx={{ fontSize: 18, color: "#1672DE", mr: 1 }} />,
                    "Receiving Entity Name": <Business sx={{ fontSize: 18, color: "#1672DE", mr: 1 }} />,
                    "Transaction date": <CalendarToday sx={{ fontSize: 18, color: "#1672DE", mr: 1 }} />,
                    "Bank Txn Id": <Receipt sx={{ fontSize: 18, color: "#1672DE", mr: 1 }} />,
                    "Broker Branch": <LocationOn sx={{ fontSize: 18, color: "#1672DE", mr: 1 }} />,
                    "Payment reference": <Payment sx={{ fontSize: 18, color: "#1672DE", mr: 1 }} />,
                    "Payment/Bank Ccy": <CurrencyExchange sx={{ fontSize: 18, color: "#1672DE", mr: 1 }} />,
                    "Bank charges": <AttachMoney sx={{ fontSize: 18, color: "#1672DE", mr: 1 }} />,
                    "Amount": <AccountBalanceOutlined sx={{ fontSize: 18, color: "#1672DE", mr: 1 }} />,
                  };
                  
                  return (
                    <span key={label} className="transaction-item">
                      <span className="transaction-item-label">
                        {iconMap[label] || <AccountBalance sx={{ fontSize: 18, color: "#1672DE", mr: 1 }} />}
                        {label}
                      </span>
                      <span className="transaction-item-value" title={value}>
                        {value}
                      </span>
                    </span>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        <div className="table-section">
          <AllocationsTable
            allocations={allocationList}
            setAllocations={setAllocationList}
            allocationsWithInitialStatus={allocationsWithInitialStatus}
            validationStatus={validationStatus}
            setValidationStatus={setValidationStatus}
            handleSave={handleSubmit}
            transaction={transactionDetails}
            selectedRowIndex={selectedRowIndex}
            setSelectedRowIndex={setSelectedRowIndex}
            apiProgressBar={apiProgressBar}
            setApiProgressBar={setApiProgressBar}
            setIsEditingRecord={setIsEditingRecord}
            policyRef={policyRef}
            updatedFields={updatedFields}
            setUpdatedFields={setUpdatedFields}
            isAuthorizedUser={isAuthorizedUser}
            openDialogueId={openDialogueId}
            setOpenDialogueId={setOpenDialogueId}
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            menuId={menuId}
            setMenuId={setMenuId}
            dialogueAllocation={dialogueAllocation}
            setDialogueAllocation={setDialogueAllocation}
            policyRefNo={policyRefNo}
            setPolicyRefNo={setPolicyRefNo}
            isEditPolicy={isEditPolicy}
            setIsEditPolicy={setIsEditPolicy}
            isAddRow={isAddRow}
            setIsAddRow={setIsAddRow}
            ROEList={ROEList}
            UpdateROEList={UpdateROEList}
            onSelectionChange={(selectionData) => {
              if (selectionData) {
                setSelectedAllocationDetails(selectionData.policy);
                setSelectedAssociatedActivities(selectionData.associatedActivities || []);
                setSelectedRowMode(selectionData.currentRowMode || "EDIT");
              } else {
                setSelectedAllocationDetails(null);
                setSelectedAssociatedActivities([]);
                setSelectedRowMode("EDIT");
              }
            }}
          />
        </div>

        {/* AllocationDetails Section Below Table - Always Visible */}
        <div className="allocation-details-section">
          {selectedAllocationDetails && selectedRowIndex >= 0 && !apiProgressBar ? (
            <AllocationDetails
              policy={allocationList[selectedRowIndex]}
              handleClose={() => {
                setSelectedAllocationDetails(null);
                setSelectedAssociatedActivities([]);
                setSelectedRowIndex(-1);
              }}
              transaction={transactionDetails}
              handleSave={async () => {
                if (allocationList[selectedRowIndex]) {
                  await handleSubmit({ 
                    policy: allocationList[selectedRowIndex], 
                    ...allocationList[selectedRowIndex] 
                  });
                  await loadData();
                  // Refresh selection data
                  const response = await instance.get(`bankmanagement/cash_allocation_activities/${allocationList[selectedRowIndex].id}/`);
                  setSelectedAssociatedActivities(response.data.data || []);
                }
              }}
              apiProgressBar={apiProgressBar}
              setApiProgressBar={setApiProgressBar}
              currentRowMode={selectedRowMode}
              associatedActivities={selectedAssociatedActivities}
              setOpenDialogueId={setOpenDialogueId}
              setViaHistoryLink={() => {}}
              setDialogueAllocation={setDialogueAllocation}
              saveDisable={false}
            />
          ) : (
            <Box sx={{ 
              padding: "40px", 
              textAlign: "center", 
              color: "#999",
              fontSize: "16px"
            }}>
              Select a row from the table above to view details
            </Box>
          )}
        </div>

        {isAPIInProgress && <CustomLoader />}

        <ToastContainer />

        {(addingRecord || isEditingRecord) && (
          <AddNewAllocation
            onSuccess={handleAddRow}
            onCancel={cancelAddRow}
            isEditingRecord={isEditingRecord}
            transaction={transactionDetails}
          />
        )}

        {/* AddNewAllocation for Contra Allocation */}
        {showContraAddNewAllocation && (
          <AddNewAllocation
            onSuccess={handleContraAddNewAllocationSuccess}
            onCancel={handleContraAddNewAllocationCancel}
            transaction={transactionDetails}
            isContraMode={true}
          />
        )}

        <DialogBox
          title="Delete Confirmation"
          body={`Are you sure you want to delete this policy ${allocationList?.[selectedRowIndex]?.policy_id}?`}
          confirmText="Delete"
          isOpen={openDeleteConfirmDialog}
          onCancel={handleDeleteCancelled}
          onConfirm={handleDeleteConfirmed}
          isDisableConfirm={isDeleteInProgress}
        />

        <DialogBox
          maxWidth="lg"
          contentWidth={900}
          title="Contra Allocation Confirmation"
          //body={<CustomContraBody />}
          child={CustomContraBody}
          confirmText="Create"
          isOpen={openContraAllocationConfirmDialog}
          onCancel={() => {
            setContraReferencePolicies([]);
            setContraComment("");
            setOpenContraAllocationConfirmDialog(false);
            setContraReferencePoliciesInputsValues({});
            setContraReferencePolicies([]);
          }}
          onConfirm={createContraAllocation}
        />

        {/* Auto Initiation Of Corective Transfer */}
        {triggerCTWorkflow && (
          <CorrectiveTransfer
            allocation={allocationList[selectedRowIndex]}
            handleClose={() => {
              // Logic to close the dialog when the handleClose function is triggered
              setTriggerCTWorkflow(false); // Or any method to control dialog visibility
            }}
            transaction={transactionDetails}
            currencies={[]}
            isAutoInitiation={true}
            isAuthorizedUser={isAuthorizedUser}
          />
        )}

        {/* Auto Initiation Of Correction Types */}
        {triggerCorrectionTypesWorkflow && (
          <CorrectionTypes
            allocation={allocationList[selectedRowIndex]}
            handleClose={() => {
              setTriggerCorrectionTypesWorkflow(false);
            }}
            transaction={transactionDetails}
            currencies={[]}
            isAutoInitiation={true}
            isAuthorizedUser={isAuthorizedUser}
          />
        )}
      </div>
      {/* Add the Dialog component for the policy error modal */}
      <Dialog
        open={isPolicyErrorModalOpen}
        onClose={handleClosePolicyErrorModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Warning!"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Policy cannot be updated as there are activities associated to it.
          </DialogContentText>
          <DialogContentText id="alert-dialog-description" sx={{ mt: 2 }}>
            Kindly check !!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClosePolicyErrorModal}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <CashAllocationEdit
        loadData={loadData}
        policy={allocationList?.[selectedRowIndex]}
        isOpen={cashAllocationDetailsEditOpen}
        onCancel={() => setCashAllocationDetailsEditOpen(false)}
      />
    </>
  );
}

// const TriggerCorrectiveTransferWorkflow = ({ currentAllocation, transactionDetails, loadData }) => {
//   const { formData, setFormData, submit } = useCorrectiveTrf(currentAllocation, transactionDetails);

//   const triggerCTWorkflowAPI = async () => {
//     setFormData({
//       ...formData,
//       bank_curr: currentAllocation?.policy_fk?.Settlement_Ccy ?? null,
//     })
//     await submit();
//     loadData();
//   }

//   useEffect(() => {
//     triggerCTWorkflowAPI();
//   }, []);

//   return (
//     <>
//     </>
//   )
// };
